import { selectChangeMessageForColor } from '@UI/aside/asideColor/asideColorSelectors';
import { selectProMenuLevel2Node } from '@newStore/documentUI/transformContent/proMenuSelectors';
import { type ExtendedBuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { proAliasesComponent } from '@nodeTypeConfig/helpers/editComponents/proAliasesComponent';
import { proThemesComponent } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
// Extends SECTION => A SECTION inside a Pro Theme and WebConfig FALLBACK_MENU_LEVEL_2 becomes a PRO_MENU_LEVEL_2
export const PRO_MENU_LEVEL_2: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectProMenuLevel2Node,
  validationRules: [],
  information: {
    description: 'Pro Channel: 2nd level in the navigation/menu structure of the Pro Home Page',
    single: 'Kanaal',
    plural: 'Kanalen',
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  ...extendsSection,
  isCollapsedByDefault: true,
  buildingBlocks: [{ type: NodeType.SECTION }],
  edit: [
    titleComponent,
    {
      component: 'color',
      reactComponent: 'AsideColor',
      property: 'color',
      label: 'Kleur',
      asideChangeMessageSelector: selectChangeMessageForColor,
    },
    {
      ...imageComponentBase,
      label: 'Ikoon',
      width: 6,
      options: { type: 'ICON', fields: [] },
    },
    proAliasesComponent,
    proThemesComponent,
  ],
  webTab: asideWebBasicConfiguration,
};
